
class NumberService {
  public abbreviateNumber (value: number) {
    const suffixes = ["", "k", "m", "b", "t"];
    let suffixNum = value === 0 ? 0 :
      Math.max(0, Math.min(suffixes.length - 1, Math.floor(Math.log10(Math.abs(value)) / 3)));
    let shortValue: string | number = parseFloat((value / Math.pow(1000, suffixNum)).toPrecision(3));
    if (Math.abs(shortValue) >= 1000 && suffixNum < suffixes.length - 1) { // 999999 rounds up to 1000k
      shortValue /= 1000;
      ++suffixNum;
    }
    if (shortValue % 1 !== 0) {
        shortValue = shortValue.toFixed(1);
    }
    return shortValue + suffixes[suffixNum];
  }
}

export default new NumberService();